<template>
  <BaseButton primary small @click="openDialog">
    <Loader v-if="loading" small inverse />
    <span v-else>Show bounces</span>
  </BaseButton>
</template>

<script>
import { emailCampaignTrackingLogsClient } from '@/api/clients';

export default {
  props: {
    emailCampaignId: {
      type: String,
      required: true,
    },
    emailMessageTrackingLogId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      emailMessageTrackingLog: null,
    };
  },
  methods: {
    async openDialog() {
      if (this.loading) {
        return;
      }

      try {
        this.loading = true;

        await this.loadEmailMessageTrackingLog();

        this.$modal.show({
          component: () =>
            import(
              '@/components/EmailMessageTrackingLog/ManageBounceLogsDialog/ManageBounceLogsDialog.vue'
            ),
          props: {
            emailMessageTrackingLog: this.emailMessageTrackingLog,
          },
          on: {},
          hideEvent: 'close',
        });
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    loadEmailMessageTrackingLog() {
      return emailCampaignTrackingLogsClient
        .read(this.emailCampaignId, this.emailMessageTrackingLogId, {
          include: 'bounceLogs',
        })
        .then((response) => {
          this.emailMessageTrackingLog = response.data;
        });
    },
  },
};
</script>
